<template>
  <v-container class="col-12">
    <v-card class="pa-3">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="report-base-filter"
          style="min-width: 200px"
        ></select-project>

        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="report-base-filter"
          style="min-width: 150px"
        />

        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 140px"
        />

        <v-btn color="info" v-on:click="search" class="mt-2" :disabled="loading" :loading="loading">Search</v-btn>
        <export :fields="exportFields" :data="filteredItems" />

        <v-row class="ma-0 pa-0">
          <v-select
            v-model="status"
            :items="statusList"
            multiple
            label="Status"
            hide-details
            class="report-base-filter"
            style="min-width: 200px"
          />
          <v-select
            v-model="type"
            :items="typeList"
            multiple
            label="Type"
            hide-details
            class="report-base-filter"
            style="min-width: 200px"
          />
          <v-combobox
            v-model="paymentMethod"
            :items="paymentMethodList"
            multiple
            clearable
            label="Payment"
            hide-details
            class="report-base-filter"
            style="min-width: 200px"
          >
            <template v-slot:selection="data">
              <span v-if="data.index === 0">{{ data.item }}</span>
            </template>
          </v-combobox>
          <v-combobox
            v-model="paymentSystem"
            :items="paymentSystemList"
            multiple
            clearable
            label="Paysystem"
            hide-details
            class="report-base-filter"
            style="min-width: 200px"
          >
            <template v-slot:selection="data">
              <span v-if="data.index === 0">{{ data.item }}</span>
            </template>
          </v-combobox>
        </v-row>
      </v-row>
    </v-card>


    <v-card class="col-12 pt-0 pb-0 px-0 mt-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        sort-by="created"
        sort-desc
        :height="`calc(100vh - 185px - ${!options.pagination ? 0 : 60}px - ${!options.padding ? 0 : options.padding}px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        fixed-header
        calculate-widths
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :hide-default-footer="!options.pagination"
        :items-per-page="options.perpage || -1"
        :footer-props="{'items-per-page-options': options.perpage ? [30, 60, 90] : [-1]}"
        :class="{nowrap, 'table-size-fixed': table_size_fixed, 'report-dt': true}"
        item-key="index"
        style="z-index: 0; position: relative; width: 100%"
      >
        <template v-slot:item.index="{ index }">
          <span>{{ index + 1 }}</span>
        </template>
        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text || header.value"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';

  ::v-deep.acceptance_rate_chart > .v-card {
    border-radius: 0 !important;
  }
</style>

<script>
  import moment from 'moment'
  import { find, get, map, filter, concat, toString } from 'lodash'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    name: 'Transaction',
    props: { title: {}, headers: {}, filters: {}, url: {}, defaultParams: { default: () => ({}) }, nowrap: { default: true }, table_size_fixed: { default: false }, options: { default: () => ({}) } },

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export'),
    },

    data: () => ({
      totalItems: -1,
      tableOptions: {},
      project: null,
      loading: false,
      items: [],
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      dateRangeList,
      accountType: [ 'casino', 'sport' ],
      paymentMethodList: [],
      paymentSystemList: [],
      typeList: [ 'deposit', 'withdraw' ],
      statusList: [ 'complete', 'pending', 'decline', 'error', 'cancel' ],
      type: [],
      status: [],
      paymentMethod: [],
      paymentSystem: [],
    }),

    computed: {
      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || ((this.filters[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filters[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    mounted () {
      this.status = [ this.statusList[0] ]
      this.type = [ this.typeList[0] ]
      this.loadPaymentSystem()
      this.loadPaymentMethod()
    },

    watch: {
      tableOptions: {
        handler () {
          if (this.options.pagination) {
            this.search()
          }
        },
        deep: true,
      },
    },

    methods: {
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },
      async loadPaymentSystem () {
        const result = await API.call('/$v/reports/paysystem/list.json', {})
        this.paymentSystemList = result.data
      },
      async loadPaymentMethod () {
        const result = await API.call('/$v/paymethod/name_list.json', {}, null, this.project)
        this.paymentMethodList = result.data.map(({ name }) => name)
      },
      search: function () {
        this.loading = true
        try {

          API.call(this.url, {
            from: this.from,
            to: this.to,
            type: this.type,
            status: this.status,
            paymethod: this.paymentMethod,
            paysystem: this.paymentSystem,
            ...this.defaultParams,
            ...this.tableOptions
          }, null, this.project).then(resp => {

            this.items = resp?.data ?? []
            if (get(resp, 'pagination', false)) {
              this.totalItems = resp.pagination.total
            }

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return this.items.map(d => d[val])
      }
    },
  }
</script>
